import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { PageEditor } from "./pages/PageEditor";
import { PageHistory } from "./pages/PageHistory";
import { Team } from "./pages/Team";
import { Shell } from "./ui/Shell";

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Shell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/pages/home" replace />} />
            <Route path="/pages" element={<Dashboard />} />
            <Route path="/pages/:slug" element={<PageEditor />} />
            <Route
              path="/pages/:slug/history"
              element={
                <ProtectedRoute adminOnly>
                  <PageHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team"
              element={
                <ProtectedRoute adminOnly>
                  <Team />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/pages/home" replace />} />
        </Routes>
        <ToastContainer position="bottom-right" autoClose={4000} />
      </BrowserRouter>
    </AuthProvider>
  );
}
